import { SecurityPage as Security} from './Security';
export default Security;
